import {ErrorDto} from './dto/Error';
import {Layout} from './dto/Layout';
import {Loader} from './dto/Loader';
import {TranslatorService} from '../translator/translator.service';
import {Injectable} from '@angular/core';

@Injectable()
export class SettingService {

  protected layout: Layout = new Layout();
  protected loader: Loader = new Loader();
  private error: ErrorDto = new ErrorDto();
  private headerSubMenuEnabled = false;
  private activityDate: Date = new Date();

  constructor(protected translator: TranslatorService) {
  }

  getLayout(): Layout {
    return this.layout;
  }

  resetSubMenu(): void {
    this.getLayout().titlePage = '';
    this.disableHeaderSubMenu();
  }

  updateLanguage(language: string): void {
    this.translator.useLanguage(language);
  }

  toggleLayoutSetting(): boolean {
    return this.layout.asideToggled = !this.layout.asideToggled;
  }

  isShowingLoader(): boolean {
    return this.loader.show;
  }

  getTypeLoader(): string {
    return this.loader.type;
  }

  setLoaderType(type: string): void {
    this.loader.type = type;
  }

  enableLoader(): void {
    this.loader.show = true;
  }

  disableLoader(): void {
    this.loader.show = false;
  }

  getError(): ErrorDto {
    return this.error;
  }

  enableHeaderSubMenu(): void {
    this.headerSubMenuEnabled = true;
  }

  disableHeaderSubMenu(): void {
    this.headerSubMenuEnabled = false;
  }

  isHeaderSubMenuEnabled(): boolean {
    return this.headerSubMenuEnabled;
  }

  getActivityDate(): Date {
    return this.activityDate;
  }

  setActivityDate(activityDate: Date): void {
    this.activityDate = activityDate;
  }

}
